import React from "react";
import "./Messages.css";
import MessageCard from "./MessageCard";
import image1 from "../../assets/team/kurur.jpeg";
import image2 from "../../assets/team/shilpi.png";

export default function Messages() {
    const messages = [
        {
            image: image1,
            name: "Narayan D. Kurur",
            designation: "Dean, Academics",
            message: "Since its formation, the Academic Outreach unit is impacting society through our diverse initiatives. From our engaging Sci-Tech seminars for high school students to the STEM Mentorship Program for young girls, we are actively shaping the next generation of innovators and leaders. By contributing to these programs, you have the opportunity to directly influence the future of science, technology, and education in the nation, and the world. Your support to these programs will help us expand these transformative efforts, inspire young minds, and create lasting change."
        },
        {
            image: image2,
            name: "Shilpi Sharma",
            designation: "Associate Dean, Outreach & New Initiatives",
            message: "At IIT Delhi, we strive towards bridging our academic excellence and cutting-edge research know-how, with societal challenges to give back to society. We believe in fostering a positive and sustainable impact through the engagement of diverse stakeholders. We invite you to join hands in our journey to bring about a change."
        }
    ];

    return (
        <div className="messages-container">
            <h1 className="messages-title">Message from <span>Deans</span></h1>
            <div className="messages-list">
                {messages.map((msg, index) => (
                    <MessageCard
                        key={index}
                        image={msg.image}
                        name={msg.name}
                        designation={msg.designation}
                        message={msg.message}
                    />
                ))}
            </div>
        </div>
    );
}
